import { normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dot_element = _resolveComponent("dot-element");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.$slots['difference-marker'] ? _renderSlot(_ctx.$slots, "difference-marker", {
    key: 0,
    style: _normalizeStyle({
      ...$options.barPosition,
      ...$options.differenceWidth
    })
  }, undefined, true) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", {
    class: "difference-bar",
    style: _normalizeStyle({
      ...$options.differenceWidth,
      height: `${$props.height}px`
    })
  }, null, 4), _createElementVNode("div", {
    class: "dashed-vertical-bar",
    style: _normalizeStyle({
      ...$options.barPosition,
      position: 'absolute'
    })
  }, null, 4), $props.value > $props.maxValue ? (_openBlock(), _createBlock(_component_dot_element, {
    key: 0,
    class: "max-dot",
    color: "white",
    size: 7,
    style: _normalizeStyle({
      ...$options.barPosition,
      position: 'absolute'
    })
  }, null, 8, ["style"])) : _createCommentVNode("", true)], 64)), _createElementVNode("div", _mergeProps({
    class: "bar",
    style: {
      ...$options.barWidth,
      height: `${$props.height}px`
    }
  }, _ctx.$attrs), null, 16)], 64);
}